import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AuthenticationService } from '../../Services/index';
import { User } from '../../Models/index';

import { contentHeaders } from '../../Core/Headers';

declare var gapi: any;
@Component({

    templateUrl: './login.component.html',
    styleUrls: ['./login.css']
   // providers: [AuthHttp]
  

})

export class LoginComponent implements OnInit {
    //model: any = {};
    token: any;
    email: string;
    source: string;
    submitted = true;
    Error = true;
    loading = false;
    returnUrl: string;
    public model = new User();
    public errorMsg = '';
    GidToken : any;

    constructor(    
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService
        //private alertService: AlertService
    ) { }

    ngOnInit() {
        if (window.localStorage.getItem('currentUser') != null) {
            this.router.navigate(['/home']);
        }
        this.submitted = true;
        this.Error = true;
       // debugger;
        this.route.queryParams.subscribe((params: Params) => {

            if (params['source'] != null) {
                this.source = params['source'];
            } else {
                this.source = '';
            }
            
        });
    }
      ngAfterViewInit() {
        gapi.signin2.render('my-signin2', {
            'scope': 'profile email',
            'width': 190,
            'height': 33,
            'longtitle': true,
            'theme': 'light',
        
        'onsuccess': param => this.onSignIn1(param)
            
        });
       
    }
	checkbox(model: any) {
        alert(model.checked)
        model.selected = (model.selected) ? false : true;
        return model.selected;
    }
     public signOut() {
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
            console.log('User signed out.');
            //this.router.navigate(['/home']);
           
            //window.location.href='#/login'
        });
    }
   public onSignIn1(googleUser) {
        if (window.location.href.indexOf('logout') > -1) {
            var auth2 = gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
                console.log('User signed out.');
                window.location.href='#/login'
            });
        }
        else {
            var user: User = new User();

            ((u:any, p) => {
                u.id = p.getId();
                u.name = p.getName();
                u.email = p.getEmail();
                this.email = u.email;
                u.imageUrl = p.getImageUrl();
                u.givenName = p.getGivenName();
                u.familyName = p.getFamilyName();
                p = null;
            })(user, googleUser.getBasicProfile());

            ((u:any, r) => {
                u.GidToken = r.id_token;
this.loginExternal(this.email, u.GidToken);
            })(user, googleUser.getAuthResponse());
        }
        //user.save();
       // this.goHome();
    };
	login(event: any) {
       
       
        this.loading = true;
        var checked = this.model.rememberMe;
        this.authenticationService.login(this.model.email, this.model.password, checked)
            .subscribe(
            data => {
                this.token = data.access_token;
               // alert(JSON.stringify(data));
                    if (data == null)
                    {
                        this.Error = false;
                   }
                    if (this.source != null && this.source != '') {
						this.token = data.access_token;
						var form: any = document.getElementById("frm");
						setTimeout(() => { window.setTimeout(form.submit()); }, 1000);
                       // setTimeout(() => { }), 20000);
                       
                    } else {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        window.localStorage.setItem('currentUser', JSON.stringify(data));
                        window.localStorage.setItem('id_token', data.access_token);
                       // this.authenticationService.loginTeam();

                        this.router.navigate(['/home']);
                    }
                    
                    
                },
                error => {
                    this.Error = false;
                    this.loading = false;               
                    console.log("error occured: "+error);
                });

    }
 loginExternal(email,GidToken) {
        this.loading = true;
        
        this.authenticationService.loginExternal(email,GidToken)
            .subscribe(
            data => {
                if (data == null) {
                    this.Error = false;
                }
                // store user details and jwt token in local storage to keep user logged in between page refreshes
      if (this.source != null && this.source != '') {
						this.token = data.access_token;
						var form: any = document.getElementById("frm");
						setTimeout(() => { window.setTimeout(form.submit()); }, 1000);
                       // setTimeout(() => { }), 20000);
                       
                       
                    } else {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        window.localStorage.setItem('currentUser', JSON.stringify(data));
                        window.localStorage.setItem('id_token', data.access_token);
                       // this.authenticationService.loginTeam();

                        window.location.href='/#/home';
                        //this.router.navigate(['/home']);
                    }            
             
            },
            error => {
                this.Error = false;
                this.loading = false;
                console.log("error occured: " + error);
            });

    }
    
    
}



// WEBPACK FOOTER //
// ./src/app/Components/login/login.component.ts